var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.schedule_headers,"items":_vm.result,"hide-default-footer":"","mobile-breakpoint":"0"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }